export default __webpack_public_path__ + "static/media/delete-bin.0286a93e.svg";